import React, { useState } from "react";

import FormField from "../../../FormField";

const Endpoint = () => {
  const [endpoint, steEndpoint] = useState();

  const handleEndpoint = (e) => {
    steEndpoint(e.target.value);
  };

  return (
    <FormField label="Endpoint">
      <input
        type="text"
        placeholder="Enter Endpoint"
        value={endpoint}
        onChange={handleEndpoint}
      />
    </FormField>
  );
};

export default Endpoint;
